import Actions from '.';
import { get} from '../../../utils/api';
import { API_ERROR_MESSAGE, USER_TYPES } from '../../../constants';

const getLeads = (id) => (async (dispatch) => {
    dispatch(Actions.updateProperty('loading', true));
    try {
        const data = await get(`user/lead?user_id=${id}`);
       
        if (data.statusCode === 201) {
            dispatch(Actions.updateProperties({
                loading: false,
                error: '',
                success: true,
                list: data.response.leads || [],
            }));
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message || API_ERROR_MESSAGE,
                list: [],
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loading: false,
            error: e.message || API_ERROR_MESSAGE,
            list: [],
        }));
    }
});
export default {
    getLeads,
}